import { configureStore } from '@reduxjs/toolkit';
import dashboardTitle from './actions/dashboardTitle';
import userTypeSlice from './actions/userTypeSlice';
import userSlice from './actions/userSlice';
import supportTicketSlice from './actions/supportTicket';
export const store = configureStore({
  reducer: {
    dashboardDetails: dashboardTitle,
    userCardType: userTypeSlice,
    userRoles: userSlice,
    supportTicket: supportTicketSlice
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
